import React, { useState, useEffect } from 'react'
import { Field } from 'redux-form'
import { StyledInput } from '../../../../components/Form/StyledInput'
import getFormValidations from './formValidations'
import _ from "lodash"

export const LOCALE_MAPPING = {
    fr: 'fr-FR', // Français (France)
    en: 'en-GB', // Anglais (Royaume-Uni)
    it: 'it-IT'  // Italien (Italie)
};

// binding for redux-form
const Input = ({ input, meta: { touched, error, active }, required, path, editable, disabled, placeholder, min, max, numberOfDecimals, t, language }) => {
    const [displayValue, setDisplayValue] = useState('')
    const translatedError = t(error)

    // Format the value when not active (blurred)
    useEffect(() => {
        if (!active && input.value !== '' && !isNaN(input.value)) {
            setDisplayValue(new Intl.NumberFormat(LOCALE_MAPPING[language],
                {
                    minimumFractionDigits: numberOfDecimals,
                    maximumFractionDigits: numberOfDecimals
                }
            ).format(input.value))
        } else {
            setDisplayValue(input.value)
        }
    }, [input.value, active, active, language])

    const handleFocus = (e) => {
        // When focusing, show the raw number
        setDisplayValue(input.value)
        input.onFocus(e)
    }

    const handleBlur = (e) => {
        // When blurring, format the number
        if (input.value !== '' && !isNaN(input.value)) {
            setDisplayValue(new Intl.NumberFormat(LOCALE_MAPPING[language],
                {
                    minimumFractionDigits: numberOfDecimals,
                    maximumFractionDigits: numberOfDecimals
                }).format(input.value))
        }
        input.onBlur(e)
    }

    const handleChange = (e) => {
        // Update the raw value
        input.onChange(e.target.value)
        setDisplayValue(e.target.value)
    }

    return (
        <StyledInput
            {...input}
            value={displayValue}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            onWheel={e => e.target.blur()}
            path={path}
            required={required}
            type={active ? "number" : "text"} // Switch between number and text type
            touched={touched}
            error={translatedError}
            disabled={disabled || !editable}
            placeholder={t(placeholder)}
            min={min}
            max={max}
            t={t}
        />
    )
}

// the binding function has to be outside to avoid re-rendering
// https://github.com/erikras/redux-form/issues/1094

const FormNumberField = ({ field, t, language, objectMode }) => {
    const {wholePositiveNumber, wholePositiveNumberStrict, minValue, maxValue, numberOfDecimals} = field
    const min = _.isNumber(minValue) ? minValue : (wholePositiveNumberStrict ? 1 : wholePositiveNumber ? 0 : undefined)
    const max = maxValue
    const validations = getFormValidations(field, t)
    return (
        <Field
            name={field.path}
            path={field.tKey || field.path}
            required={field.required}
            component={Input}
            placeholder={field.placeholder}
            validate={validations}
            disabled={field.disabled || !field.writable}
            editable={!field.editable ? objectMode === 'newObject' : field.editable}
            normalize={(value) => {
                if(value === "" || !_.isNumber(parseFloat(value))) return null //to handle no value, if the user delete everything
                if(!_.isUndefined(max) && parseFloat(value) > parseFloat(max)) return max
                if(!_.isUndefined(min) && parseFloat(value) < min) return min
                return parseFloat(value)
            }}
            wholePositiveNumberStrict={field.wholePositiveNumberStrict}
            min={min}
            max={max}
            numberOfDecimals={numberOfDecimals}
            t={t}
            language={language}
        />
    )
}

export default FormNumberField
